import React from 'react';
import { Sun, Moon, MoonStar, Zap } from 'lucide-react';
import '../styles/ThemeToggle.css';

const ThemeToggle = ({ theme, toggleTheme, texts }) => {
  const t = (key, fallback) => (texts && texts[key]) || fallback;

  const getThemeTitle = () => {
    switch (theme) {
      case 'light': return t('theme_toggle_to_dark', 'Switch to Dark Mode');
      case 'dark': return t('theme_toggle_to_true_dark', 'Switch to True Dark (OLED) Mode');
      case 'true-dark': return t('theme_toggle_to_neon', 'Switch to Neon Mode');
      case 'neon': return t('theme_toggle_to_light', 'Switch to Light Mode');
      default: return t('theme_toggle_aria', 'Switch theme');
    }
  };

  const getThemeIcon = () => {
    switch (theme) {
      case 'light': return <Moon size={16} />;
      case 'dark': return <MoonStar size={16} />;
      case 'true-dark': return <Zap size={16} />;
      case 'neon': return <Sun size={16} />;
      default: return <Sun size={16} />;
    }
  };

  return (
    <button
      type="button"
      className={`theme-toggle-button ${theme === 'neon' ? 'neon-theme' : ''}`}
      onClick={toggleTheme}
      aria-label={getThemeTitle()}
      title={getThemeTitle()}
    >
      {getThemeIcon()}
    </button>
  );
};

export default ThemeToggle;
